import { Box, GridItem } from '@chakra-ui/react'
import { Campus, InventoryProvider } from 'content-service'
import { FinderDetailBanner, Gallery, GalleryItems, GridLayout, H2, H3, SocialLinks } from 'ui'
import { HtmlStringParser } from 'ui/src/components/HtmlStringParser'
import { useMediaQuery } from 'utils/src/helpers'
import {
  collateCampusNames,
  validateDefaultCampusProps,
  validateProviderDetailProps,
} from './helpers'

interface ProviderDetailCampusesTabProps {
  providerDetail: InventoryProvider
  pageUrl: string
  defaultCampus: Campus | null
  galleryItems?: GalleryItems[]
}

const ProviderDetailCampusesTab = ({
  defaultCampus,
  providerDetail,
  pageUrl,
  galleryItems,
}: ProviderDetailCampusesTabProps) => {
  const isDesktop = useMediaQuery('(min-width: 992px)')
  const campusesArray = providerDetail?.campuses?.filter((campus) => campus?.active)
  const { descriptionHtmlString, siteUrl, subtypeList, type } =
    validateProviderDetailProps(providerDetail)
  const { phoneNumber, address, name, city } = validateDefaultCampusProps(defaultCampus)
  const campuses = collateCampusNames(campusesArray)
  const isNZSchool = providerDetail.type?.name === 'NZ School'
  const titleType = isNZSchool ? 'School' : 'course'

  return (
    <Box>
      <GridLayout>
        <GridItem colSpan={{ base: 4, md: 5, lg: 7 }}>
          <Box marginBottom={14} borderTopColor="deepblue.200">
            {descriptionHtmlString && (
              <Box marginBottom="60px">
                <H2 data-type="jump-ahead" data-name="Summary" data-title="Summary">
                  Summary
                </H2>
                <HtmlStringParser htmlString={descriptionHtmlString} />
              </Box>
            )}
          </Box>
          {galleryItems && galleryItems.length > 0 && (
            <Box mb={{ base: '60px', lg: 6 }}>
              <H3>Gallery</H3>
              <Gallery galleryItems={galleryItems} centerSlidePercentage={!isDesktop ? 90 : 65} />
            </Box>
          )}
        </GridItem>
        <GridItem
          colSpan={{ base: 4, md: 3, lg: 4 }}
          colStart={{ base: 1, md: 6, lg: 9 }}
          gridRow={1}
        >
          <FinderDetailBanner title="Contact details" type="contact">
            <FinderDetailBanner.Contact
              name={name}
              city={city}
              address={address}
              phone={phoneNumber}
              campuses={campuses}
              siteUrl={siteUrl}
              type={type}
              subtypeList={subtypeList}
            />
          </FinderDetailBanner>
          <Box display={{ base: 'none', md: 'block' }} marginBottom={16}>
            <SocialLinks
              title={`Share this ${titleType}`}
              pageUrl={pageUrl}
              socialItems={['facebook', 'twitter', 'email']}
              pageInfo={name}
            />
          </Box>
        </GridItem>
      </GridLayout>
      <Box display={{ base: 'block', md: 'none' }} marginBottom={16}>
        <SocialLinks
          title={`Share this ${titleType}`}
          pageUrl={pageUrl}
          socialItems={['facebook', 'twitter', 'email']}
          pageInfo={name}
        />
      </Box>
    </Box>
  )
}

export default ProviderDetailCampusesTab
